import { Component, OnInit, inject } from '@angular/core';
import { CurrencyPipe, NgClass, NgOptimizedImage } from '@angular/common';
import { DashboardApiService } from '../../../../../_services/dashboard-api-service/dashboard-api.service';
import { AverageSpendWidget } from '../../../../../_interfaces/dashboard.interface';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { DashboardWidgetBaseComponent } from '../dashboard-widget-base.component';
import { EmptyIndicatorPipe } from '../../../../../shared/pipes/empty-indicator.pipe';

@Component({
  selector: 'app-average-spend-widget',
  imports: [CurrencyPipe, NgbTooltip, NgClass, EmptyIndicatorPipe, NgOptimizedImage],
  templateUrl: './average-spend-widget.component.html',
  styles: `
    .img-container {
      position: relative;
      height: 128px;
      img {
        object-fit: contain;
      }
    }
  `,
})
export class AverageSpendWidgetComponent extends DashboardWidgetBaseComponent implements OnInit {
  readonly dashboardApiService = inject(DashboardApiService);

  protected averageSpend: AverageSpendWidget | undefined;

  ngOnInit() {
    this.dashboardApiService.getAverageSpendDetails().subscribe({
      next: (res) => {
        this.isLoading = false;
        this.averageSpend = res;
      },
    });
  }
}
